import React from 'react';
import { cx } from './cx';

// §5: structure is a value step, not a border and never a shadow. A card is a
// carbon-850 panel on the carbon-950 ground — the 1.11:1 step does the
// separating that 127 hairline borders used to do.
// §4: radius 0. §3: panel density, 16px padding.
const BASE = 'bg-carbon-850 rounded-radius-none p-space-6';

// Interactive cards (the HomePage tiles) need hover and focus. Motion is named
// and limited to background-color per §6.
const INTERACTIVE = [
  'text-left w-full',
  'transition-[background-color,color] duration-fast ease-standard',
  'hover:bg-carbon-800',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
].join(' ');

export default function Card({ as, interactive = false, className, ...rest }) {
  const As = as || (interactive ? 'button' : 'div');
  const extra = As === 'button' ? { type: 'button' } : {};
  return (
    <As
      className={cx(BASE, interactive && INTERACTIVE, className)}
      {...extra}
      {...rest}
    />
  );
}
